<template>
  <div class="flex flex-wrap items-start" :class="props.isActive ? 'text-gray-80' : 'text-gray-60'">
    <p class="mr-1 whitespace-nowrap">{{ $t('promo.expire_at') }}</p>
    <p>{{ formatDateWithI18n(props.endAt, 'MMMDYYYYHHMM') }}</p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  endAt: string
  isActive?: boolean
}

const props = withDefaults(defineProps<Props>(), { isActive: true })

const { formatDateWithI18n } = useI18nDateString()
</script>
